import { useExtensionInstalled } from '@/hooks/use-extension-installed.hook';

export interface ExtensionNavigationState {
  detectionReady: boolean;
  installedInBrowser: boolean;
  showSidebarInstaller: boolean;
  showIntegrationsSurface: boolean;
}

export function getExtensionNavigationState(
  detectionReady: boolean,
  installedInBrowser: boolean
): ExtensionNavigationState {
  const confirmedInstalled = detectionReady && installedInBrowser;

  return {
    detectionReady,
    installedInBrowser: confirmedInstalled,
    showSidebarInstaller: !confirmedInstalled,
    showIntegrationsSurface: confirmedInstalled,
  };
}

/** Keeps the sidebar, Integrations route, and installer route in one state. */
export function useExtensionNavigation(): ExtensionNavigationState {
  const installation = useExtensionInstalled();

  return getExtensionNavigationState(
    installation.isReady,
    installation.isInstalled
  );
}
